import React from 'react';
import { connect } from 'react-redux';

import Input from '@components/Input';
import { setBeamShiftX, setBeamShiftY } from '@reducers/options/beam/actions';

import { unitLabel, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../../src/texts/tooltips';

const AxisPosition = props => (
  <div className="calculation">
    <section className="list-type">
     <Tooltip content={APP_TOOLTIPS.TOOLTIP_AXIS_POSITION_X.Content}>
      <Input
        id="ex"
        prefix="Ex ="
        postfix={unitLabel(props.unit)}
        type="number"
        disabled={props.predefinedBasePlate && props.predefinedBasePlate.isPredefinedBasePlate}
        value={unitTransform(props.shift.x || 0).from(defaultUnits.DISTANCE).to(props.unit)}
        onUpdate={value => {
          props.setEx(value, props.unit);
        }}
      />
      </Tooltip>

      <Tooltip content={APP_TOOLTIPS.TOOLTIP_AXIS_POSITION_Y.Content}>
      <Input
        id="ey"
        prefix="Ey ="
        postfix={unitLabel(props.unit)}
        type="number"
        disabled={props.predefinedBasePlate && props.predefinedBasePlate.isPredefinedBasePlate}
        value={unitTransform(props.shift.y || 0).from(defaultUnits.DISTANCE).to(props.unit)}
        onUpdate={value => {
          props.setEy(value, props.unit);
        }}
      />
      </Tooltip>
    </section>
  </div>
);

const mapState = state => ({
  shift: state.options.beam.shift,
  unit: state.main.units.distance,
  predefinedBasePlate: state.selectors.application[state.main.appType].predefinedBasePlate
});

const mapDispatch = dispatch => ({
  setEx: (value, unit) => dispatch(setBeamShiftX(unitTransform(+value, false).from(unit).to(defaultUnits.DISTANCE))),
  setEy: (value, unit) => dispatch(setBeamShiftY(unitTransform(+value, false).from(unit).to(defaultUnits.DISTANCE)))
});

export default connect(mapState, mapDispatch)(AxisPosition);



// WEBPACK FOOTER //
// ./src/views/Dimension/components/AxisPosition/index.js